import { formatDateDayStart } from './time';

export const generateDatesInRange = (
  start?: string | null,
  end?: string | null
) => {
  if (!start || !end) {
    return [];
  }
  const startDate = new Date(start);
  const endDate = new Date(end);
  const currentDate = new Date(startDate);
  const dates = [];
  while (currentDate <= endDate) {
    dates.push(formatDateDayStart(currentDate)!);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
};
